/** TanStack query roots scoped to employer managed-organisation context. */
export const EMPLOYER_ORGANISATION_QUERY_ROOTS = [
  'organisation-opportunities',
  'organisation-opportunity',
  'organisation',
  'opportunity-applicants',
  'managed-org-recent-applicants',
  'evaluations',
  'opportunities',
  'applications',
  'interviewer-candidates',
] as const

export function invalidateEmployerOrganisationScopedQueries(
  qc: { invalidateQueries: (opts: { queryKey: string[] }) => unknown },
): void {
  for (const k of EMPLOYER_ORGANISATION_QUERY_ROOTS) {
    void qc.invalidateQueries({ queryKey: [k] })
  }
}
